import React, { useState, useEffect } from "react";

// Icons as simple components
const CalendarTodayIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
  </svg>
);

const StickyNote2Icon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5A2,2 0 0,0 17,3M17,18L12,15.82L7,18V5H17V18Z"/>
  </svg>
);

const NotificationsIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,22 C13.1,22 14,21.1 14,20 L10,20 C10,21.1 10.9,22 12,22 Z M18,16 L18,11 C18,7.93 16.36,5.36 13.5,4.68 L13.5,4 C13.5,3.17 12.83,2.5 12,2.5 C11.17,2.5 10.5,3.17 10.5,4 L10.5,4.68 C7.63,5.36 6,7.92 6,11 L6,16 L4,18 L4,19 L20,19 L20,18 L18,16 Z"/>
  </svg>
);

const ListIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3,5H9V3H3A2,2 0 0,0 1,5V9H3V5M5,21V19H3A2,2 0 0,0 5,21M19,3H21A2,2 0 0,1 23,5V9H21V5H19V3M21,21A2,2 0 0,1 19,23V21H21M22,11H2V13H22V11Z"/>
  </svg>
);

const BuildIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.7,19L13.6,9.9C14.5,7.6 14,4.9 12.1,3C10.1,1 7.1,0.6 4.7,1.7L9,6L6,9L1.6,4.7C0.4,7.1 0.9,10.1 2.9,12.1C4.8,14 7.5,14.5 9.8,13.6L18.9,22.7C19.3,23.1 19.9,23.1 20.3,22.7L22.6,20.4C23.1,20 23.1,19.3 22.7,19Z"/>
  </svg>
);

const EventIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17,12H5V10H17M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,4.11 20.1,3 19,3M19,19H5V8H19V19Z"/>
  </svg>
);

const WebStoriesIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z"/>
  </svg>
);

const HomeIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"/>
  </svg>
);

const QuoteIcon = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
    <g>
      <path 
        d="M12 35.5C12 31.4 12.9 27.7 14.7 24.4C16.5 21 19 18.3 22.2 16.3L26 21.1C23.9 22.3 22.2 23.9 20.9 25.9C19.7 27.8 19 29.9 18.8 32.2H24.5V42.5H12V35.5Z"
        fill="#663399"
        opacity="0.6"
      />
      <path 
        d="M35.5 35.5C35.5 31.4 36.4 27.7 38.2 24.4C40 21 42.5 18.3 45.7 16.3L49.5 21.1C47.4 22.3 45.7 23.9 44.4 25.9C43.2 27.8 42.5 29.9 42.3 32.2H48V42.5H35.5V35.5Z"
        fill="#be61f9"
        opacity="0.5"
      />
    </g>
  </svg>
);

// Colors
const primaryColor = "#b93183"; 
const secondaryColor = "#be61f9"; 
const tealColor = "#28c1d5";
const redColor = "#ff5733";
const greenColor = "#33cc33";
const yellowColor = "#f4c542";
const pinkColor = "#ff33a6";
const blueColor = "#17a2b8";

const styles = {
  heroSection: {
    backgroundColor: '#f5f5f5', 
    padding: '6rem 0',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  
  heroOverlay: {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) rotate(45deg)',
    width: '150%',
    height: '150%',
    background: `linear-gradient(45deg, rgba(255, 255, 255, 0.1), rgba(102, 51, 153, 0.1))`,
    zIndex: 0,
  },

  sectionTitle: {
    fontFamily: "saira,sans-serif",
    fontWeight: 'bold',
    fontSize: '2rem',
    color: '#000',
    marginBottom: '1rem',
    position: 'relative',
    zIndex: 1,
  },

  subtitle: {
    fontFamily: "saira,sans-serif",
    fontSize: '1.25rem',
    color: '#555',
    marginBottom: '1rem', 
    position: 'relative',
    zIndex: 1,
  },

  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem'
  },

  featureItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '1.5rem',
    margin: '1rem',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'pointer',
  },

  readMoreButton: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '0.75rem 2rem', 
    fontSize: '0.9rem', 
    marginTop: '1rem', 
    width: 'fit-content',
    textTransform: 'none',
    border: 'none',
    cursor: 'pointer',
    margin: '1rem auto',
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '2rem',
    marginTop: '2rem',
    justifyContent: 'center'
  },

  testimonialSection: {
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
    padding: '5rem 0',
    color: '#fff',
    position: 'relative',
    overflow: 'hidden',
  },

  testimonialContainer: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 2rem',
  },

  testimonialHeader: {
    textAlign: 'center',
    marginBottom: '3.5rem',
  },

  testimonialTitle: {
    fontFamily: "saira,sans-serif",
    fontSize: '2rem',
    fontWeight: '800',
    marginBottom: '0.5rem',
    letterSpacing: '-0.02em',
    textShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },

  testimonialSubtitle: {
    fontFamily: "saira,sans-serif",
    fontSize: '1rem',
    opacity: 0.95,
    fontWeight: '400',
  }
};

// Improved Slider Component
const ProfessionalSlider = ({ children, settings = {} }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const slides = React.Children.toArray(children);
  
  const sliderSettings = {
    dots: settings.dots !== undefined ? settings.dots : true,
    infinite: settings.infinite !== undefined ? settings.infinite : true,
    speed: settings.speed || 600,
    slidesToShow: settings.slidesToShow || 3,
    slidesToScroll: settings.slidesToScroll || 1,
    autoplay: settings.autoplay !== undefined ? settings.autoplay : true,
    autoplaySpeed: settings.autoplaySpeed || 5000,
  };

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying || !sliderSettings.autoplay) return;
    
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, sliderSettings.autoplaySpeed);
    
    return () => clearInterval(timer);
  }, [slides.length, isAutoPlaying, sliderSettings.autoplay, sliderSettings.autoplaySpeed]);

  // Responsive slides to show
  const [slidesToShow, setSlidesToShow] = useState(sliderSettings.slidesToShow);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 640) {
        setSlidesToShow(1);
      } else if (width <= 1024) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(sliderSettings.slidesToShow);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sliderSettings.slidesToShow]);

  const nextSlide = () => {
    setIsAutoPlaying(false);
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const prevSlide = () => {
    setIsAutoPlaying(false);
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentSlide(index);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const sliderStyles = {
    wrapper: {
      position: 'relative',
      width: '100%',
      margin: '0 auto',
    },
    sliderContainer: {
      position: 'relative',
      width: '100%',
      overflow: 'hidden',
      borderRadius: '20px',
      padding: '20px 0',
    },
    sliderTrack: {
      display: 'flex',
      transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
      transform: `translateX(-${currentSlide * (100 / slidesToShow)}%)`,
    },
    slide: {
      minWidth: `${100 / slidesToShow}%`,
      padding: '0 15px',
      boxSizing: 'border-box',
    },
    arrow: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      backgroundColor: 'rgba(255,255,255,0.98)',
      borderRadius: '50%',
      width: '52px',
      height: '52px',
      cursor: 'pointer',
      fontSize: '20px',
      color: primaryColor,
      zIndex: 10,
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '600',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      border: '2px solid rgba(102, 51, 153, 0.1)',
  
    },
    prevArrow: {
      left: '2px',
    },
    nextArrow: {
      right: '2px',
    },
    dots: {
      display: 'flex',
      justifyContent: 'center',
      gap: '8px',
      marginTop: '2.5rem',
      listStyle: 'none',
      padding: 0,
    },
    dot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255,255,255,0.3)',
      cursor: 'pointer',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      border: 'none',
      padding: 0,
    },
    activeDot: {
      width: '32px',
      borderRadius: '4px',
      backgroundColor: '#fff',
    }
  };

  return (
    <div style={sliderStyles.wrapper}>
      <div style={sliderStyles.sliderContainer}>
        <button 
          style={{...sliderStyles.arrow, ...sliderStyles.prevArrow}}
          onClick={prevSlide}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-50%) scale(1.08)';
            e.currentTarget.style.boxShadow = '0 6px 28px rgba(0,0,0,0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
          }}
          aria-label="Previous testimonial"
        >
          ←
        </button>
        
        <div style={sliderStyles.sliderTrack}>
          {slides.map((slide, index) => (
            <div key={index} style={sliderStyles.slide}>
              {slide}
            </div>
          ))}
        </div>
        
        <button 
          style={{...sliderStyles.arrow, ...sliderStyles.nextArrow}}
          onClick={nextSlide}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-50%) scale(1.08)';
            e.currentTarget.style.boxShadow = '0 6px 28px rgba(0,0,0,0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
          }}
          aria-label="Next testimonial"
        >
          →
        </button>
      </div>

      {sliderSettings.dots && (
        <ul style={sliderStyles.dots}>
          {Array.from({ length: Math.ceil(slides.length / slidesToShow) }, (_, index) => (
            <li key={index}>
              <button
                style={{
                  ...sliderStyles.dot,
                  ...(Math.floor(currentSlide / slidesToShow) === index ? sliderStyles.activeDot : {})
                }}
                onClick={() => goToSlide(index * slidesToShow)}
                aria-label={`Go to slide ${index + 1}`}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const TestimonialCard = ({ rating, author, role, text }) => {
  const cardStyles = {
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
    borderRadius: '20px',
    padding: '1.5rem',
    height: '333px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'default',
    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
    border: '1px solid rgba(102, 51, 153, 0.08)',
  };

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      style={{
        ...cardStyles,
        transform: isHovered ? 'translateY(-8px) scale(1.02)' : 'translateY(0) scale(1)',
        boxShadow: isHovered ? '0 20px 60px rgba(0,0,0,0.15)' : '0 10px 40px rgba(0,0,0,0.08)',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Quote Icon */}
      <div style={{ 
        position: 'absolute', 
        top: '16px', 
        right: '16px',
        width: '64px',
        height: '64px',
        backgroundColor: 'rgba(102, 51, 153, 0.08)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      }}>
        <QuoteIcon />
      </div>

      {/* Rating */}
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{
          display: 'inline-flex',
          gap: '4px',
          padding: '8px 12px',
          backgroundColor: 'rgba(102, 51, 153, 0.08)',
          borderRadius: '100px',
        }}>
          {[...Array(5)].map((_, i) => (
            <span key={i} style={{
              color: i < rating ? '#FFD700' : '#E0E0E0',
              fontSize: '18px',
              filter: i < rating ? 'drop-shadow(0 1px 3px rgba(255, 215, 0, 0.4))' : 'none',
            }}>
              ★
            </span>
          ))}
        </div>
      </div>

      {/* Testimonial Text */}
      <div style={{ flex: 1, marginBottom: '1.5rem' }}>
        <p style={{
          fontSize: '1.1rem',
          lineHeight: '1.7',
          color: '#444',
          fontStyle: 'italic',
          position: 'relative',
        }}>
          "{text}"
        </p>
      </div>

      {/* Author Info */}
      <div style={{
        borderTop: '2px solid rgba(102, 51, 153, 0.08)',
        paddingTop: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '18px',
          flexShrink: 0,
        }}>
          {author.charAt(0)}
        </div>
        <div>
          <div style={{
            fontWeight: '600',
            color: '#222',
            fontSize: '1.05rem',
            marginBottom: '2px',
          }}>
            {author}
          </div>
          <div style={{
            color: '#666',
            fontSize: '0.9rem',
          }}>
            {role}
          </div>
        </div>
      </div>
    </div>
  );
};

const categories = [
  { title: "Planner", icon: <CalendarTodayIcon />, color: "#be61f9", description: "Organize your schedule efficiently." },
  { title: "Sticky Notes", icon: <StickyNote2Icon />, color: "#28c1d5", description: "Quickly jot down important notes." },
  { title: "Reminder", icon: <NotificationsIcon />, color: "#ff5733", description: "Set reminders for your tasks and events." },
  { title: "To Do List", icon: <ListIcon />, color: "#33cc33", description: "Keep track of your daily tasks." },
  { title: "Campus QuickLinks", icon: <BuildIcon />, color: "#f4c542", description: "Access essential campus resources instantly." },
  { title: "Upcoming Events", icon: <EventIcon />, color: "#ff33a6", description: "Stay updated on upcoming campus events." },
  { title: "Campus AI Agent", icon: <WebStoriesIcon />, color: "#6610f2", description: "Get AI-powered assistance for campus queries." },
  { title: "Dorm $", icon: <HomeIcon />, color: "#17a2b8", description: "Manage dorm expenses and budgeting." }
];

// Updated testimonials to match student tools theme
const testimonials = [
  {
    rating: 5,
    author: "Sarah Chen",
    role: "Computer Science, Senior",
    text: "The planner and reminder features have completely transformed how I manage my coursework. I haven't missed a deadline since I started using these tools!",
  },
  {
    rating: 5,
    author: "Marcus Johnson",
    role: "Engineering, Junior",
    text: "The Campus AI Agent is incredible! It helps me find resources instantly and the sticky notes feature keeps all my quick thoughts organized. Essential for any busy student.",
  },
  {
    rating: 5,
    author: "Emily Rodriguez",
    role: "Pre-Med, Sophomore",
    text: "These tools saved my GPA! The to-do list keeps me on track, and the upcoming events feature ensures I never miss important campus activities or study sessions.",
  },
  {
    rating: 4,
    author: "James Park",
    role: "Business, Freshman",
    text: "As a freshman, the Campus QuickLinks have been a lifesaver. I can find everything I need without getting lost in the university website maze.",
  },
  {
    rating: 5,
    author: "Aisha Patel",
    role: "Psychology, Graduate",
    text: "The Dorm $ feature helped me save over $500 last semester! Combined with the planner, I'm more organized than ever in both academics and finances.",
  },
  {
    rating: 5,
    author: "Tom Williams",
    role: "Arts & Design, Senior",
    text: "Simple, intuitive, and powerful. These tools understand what students actually need. The reminder system alone has improved my productivity by 40%.",
  },
];

const Studenttools = () => {
  // Add class name to body tag
  useEffect(() => {
    document.body.className = 'landing';
    
    // Clean up on component unmount
    return () => {
      document.body.className = '';
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <>
      <div style={styles.heroSection}>
        <div style={styles.heroOverlay}></div>
        <div style={styles.container}>
          <h1 style={styles.sectionTitle}>Level Up Your Studies with Smarter Student Tools</h1>
          <p style={styles.subtitle}>Enhance learning with modern resources for note-taking, time mastery, and effortless collaboration.<br /> Perfect for students at every step of their journey!</p>
          <button style={styles.readMoreButton}>Read More</button>
          <div style={styles.grid}>
            {categories.map((category, index) => (
              <div 
                key={index}
                style={styles.featureItem}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{ color: category.color, fontSize: '3rem', marginBottom: '0.5rem' }}>
                  {category.icon}
                </div>
                <h3 style={{ fontWeight: 'bold', color: '#000', marginBottom: '0.25rem', margin: '0.5rem 0 0.25rem 0' }}>
                  {category.title}
                </h3>
                <p style={{ color: '#777', fontSize: '0.9rem', margin: 0 }}>
                  {category.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={styles.testimonialSection}>
        <div style={styles.testimonialContainer}>
          <div style={styles.testimonialHeader}>
            <h2 style={styles.testimonialTitle}>Trusted by Students Worldwide</h2>
            <p style={styles.testimonialSubtitle}>Join thousands of students who've transformed their academic journey</p>
          </div>
          
          <ProfessionalSlider settings={settings}>
            {testimonials.map((testimonial, index) => (
              <TestimonialCard key={index} {...testimonial} />
            ))}
          </ProfessionalSlider>
        </div>

        {/* Background decoration */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.03,
          background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          pointerEvents: 'none',
        }} />
      </div>

      {/* College App Section */}
      <div style={{
        backgroundColor: '#f8f8f8',
        padding: '5rem 0',
        textAlign: 'center',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem',
        }}>
          <h2 style={{
            fontFamily: "saira,sans-serif",
            fontSize: '2rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: '#000',
          }}>
            Campus Just <span style={{
              background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              color: 'transparent',
              display: 'inline-block',
              padding: '0 0.5rem',
            }}>Got Easier.</span>
          </h2>
          
          <p style={{
            fontSize: '1rem',
            color: '#555',
            marginBottom: '4rem',
            fontFamily: "saira,sans-serif",
          }}>
            Get everything done from the comfort and familiarity of your phone.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '3rem',
          }}>
            {/* Secure */}
            <div>
              <div style={{
                marginBottom: '1rem',
                display: 'flex',
                justifyContent: 'center',
              }}>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" 
                    fill={primaryColor} />
                </svg>
              </div>
              <h3 style={{
                fontFamily: "saira,sans-serif",
                fontSize: '1.5rem',
                fontWeight: 'bold',
                marginBottom: '0.75rem',
                color: '#000',
              }}>
                Secure
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.6',
              }}>
                .edu authentication and buyer protection on purchases.
              </p>
            </div>

            {/* Lightning-fast */}
            <div>
              <div style={{
                marginBottom: '1rem',
                display: 'flex',
                justifyContent: 'center',
              }}>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M7 2v11h3v9l7-12h-4l3-8z" 
                    fill={secondaryColor} />
                </svg>
              </div>
              <h3 style={{
                fontFamily: "saira,sans-serif",
                fontSize: '1.5rem',
                fontWeight: 'bold',
                marginBottom: '0.75rem',
                color: '#000',
              }}>
                Lightning-fast
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.6',
              }}>
                Post your first listing in under a minute.
              </p>
            </div>

            {/* Verified Students */}
            <div>
              <div style={{
                marginBottom: '1rem',
                display: 'flex',
                justifyContent: 'center',
              }}>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <g>
                    <circle cx="12" cy="8" r="3.5" fill={primaryColor} opacity="0.9"/>
                    <path d="M12 13c-3.86 0-7 1.57-7 3.5V19h14v-2.5c0-1.93-3.14-3.5-7-3.5z" 
                      fill={primaryColor} opacity="0.9"/>
                    <circle cx="18" cy="16" r="5" fill={secondaryColor} />
                    <path d="M16.5 18.5l-2-2 .7-.7 1.3 1.3 3.3-3.3.7.7-4 4z" fill="white"/>
                  </g>
                </svg>
              </div>
              <h3 style={{
                fontFamily: "saira,sans-serif",
                fontSize: '1.5rem',
                fontWeight: 'bold',
                marginBottom: '0.75rem',
                color: '#000',
              }}>
                Verified Students
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.6',
              }}>
                Trade with other students, not strangers.
              </p>
            </div>

            {/* Intuitive */}
            <div>
              <div style={{
                marginBottom: '1rem',
                display: 'flex',
                justifyContent: 'center',
              }}>
              </div>

            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          h2 {
            font-size: 2.5rem !important;
          }
        }
        
        @media (max-width: 640px) {
          h2 {
            font-size: 2rem !important;
          }
          
          .testimonial-slider-container {
            padding: 0 40px !important;
          }
        }

        * {
          box-sizing: border-box;
        }
      `}</style>
    </>
  );
};

export default Studenttools;